import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
import { t } from '../utils/translations';
import { MapPin } from 'lucide-react';
export function CoverageMap() {
  const {
    lang
  } = useLanguage();
  const text = t[lang].coverage;
  const cities = ['Miami', 'Orlando', 'Tampa', 'Jacksonville', 'Fort Lauderdale', 'Sarasota', 'Naples', 'West Palm Beach', 'Boca Raton', 'St. Petersburg', 'Delray Beach', 'Jupiter', 'Palm Bay', 'Melbourne', 'Doral', 'Weston', 'Winter Haven', 'Altamonte Springs', 'Okeechobee', 'New Smyrna Beach', 'Largo', 'Clearwater', 'Tallahassee', 'Pensacola', 'Gainesville', 'Lakeland', 'Fort Myers', 'Port St. Lucie', 'Palm Coast', 'Daytona Beach', 'Bradenton', 'Kissimmee', 'Venice', 'Hollywood', 'Bonita Springs', 'Coral Springs', 'Winter Park', 'Deerfield Beach', 'Destin', 'Panama City', 'Sebring', 'Riverview', 'Pompano Beach', 'Homestead', 'Cape Coral', 'North Port', 'Lehigh Acres', 'Miramar', 'Aventura', 'Hialeah', 'Davie', 'Margate', 'Pembroke Pines', 'Coconut Creek', 'Lake Worth', 'Wellington', 'Ocala', 'St. Augustine', 'Apopka', 'Vero Beach', 'Sanford', 'Key West', 'Wesley Chapel'];
  return <section className="py-20 bg-white border-b border-gray-200" data-id="element-85">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86">
        <div className="text-center mb-16" data-id="element-87">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-condensed font-black text-mf-black uppercase tracking-tight mb-4" data-id="element-88">
            {text.title}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-89">
            {text.subtitle}
          </motion.p>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-90">
          {/* Map Graphic */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="w-full lg:w-1/3 relative flex justify-center" data-id="element-91">
            {/* Simplified SVG representation of Florida */}
            <svg viewBox="0 0 400 400" className="w-full max-w-sm h-auto drop-shadow-xl" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-92">
              <path d="M50 50 L150 50 L180 80 L200 150 L250 200 L300 250 L320 350 L280 380 L250 350 L200 300 L150 250 L100 150 L50 100 Z" fill="#212121" stroke="#424242" strokeWidth="2" data-id="element-93" />
              {/* Decorative Pins */}
              {[{
              x: 100,
              y: 80
            }, {
              x: 180,
              y: 120
            }, {
              x: 220,
              y: 180
            }, {
              x: 260,
              y: 240
            }, {
              x: 290,
              y: 300
            }, {
              x: 300,
              y: 340
            }, {
              x: 240,
              y: 320
            }, {
              x: 150,
              y: 200
            }, {
              x: 120,
              y: 140
            }].map((pos, i) => <g key={i} transform={`translate(${pos.x}, ${pos.y})`} data-id="element-94">
                  <circle cx="0" cy="0" r="6" fill="#D32F2F" data-id="element-95" />
                  <circle cx="0" cy="0" r="12" fill="#D32F2F" opacity="0.3" data-id="element-96">
                    <animate attributeName="r" values="6;18;6" dur="2s" repeatCount="indefinite" data-id="element-97" />
                    <animate attributeName="opacity" values="0.5;0;0.5" dur="2s" repeatCount="indefinite" data-id="element-98" />
                  </circle>
                </g>)}
            </svg>
          </motion.div>

          {/* Cities Grid */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full lg:w-2/3" data-id="element-99">
            <div className="bg-gray-50 rounded-xl p-6 md:p-8 border border-gray-200" data-id="element-100">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-3" data-id="element-101">
                {cities.map((city, index) => <div key={index} className="flex items-center text-sm md:text-base text-gray-700 font-medium" data-id="element-102">
                    <MapPin size={14} className="text-mf-red mr-1.5 flex-shrink-0" data-id="element-103" />
                    <span className="truncate" data-id="element-104">{city}</span>
                  </div>)}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}